import ManageOder from './index'
import OrderDetail from './order-detail'

export default [
  {
    path: '/manage-order',
    component: ManageOder
  },
  {
    name: '/manage-order/order-detail',
    path: '/manage-order/order-detail',
    component: OrderDetail,
    props: (route) => ({
      orderId: route.query.id ? route.query.id : route.params.orderId,
      mode: route.query.mode ? route.query.mode : route.params.mode,
      data: route.params.data
    }),
  },
]
